import { User, Profession } from "../../user";

// 対応責任者
export class ReceptionManager {
  constructor(
    public displayOrder: number,
    public staff: User,
  ) { }

  clone(): ReceptionManager {
    return new ReceptionManager(
      this.displayOrder,
      this.cloneUser()
    );
  }

  private cloneUser(): User {
    return new User(
      this.staff.id,
      this.staff.name,
      this.staff.profession
        ? new Profession(this.staff.profession.id, this.staff.profession.name, this.staff.profession.category)
        : null,
      this.staff.kanaName,
      this.staff.email,
      this.staff.phone,
    );
  }
}
